// Share a meeting read-only with colleagues: the shared people picker wired to
// the Meetly API. Recipients can read the summary, action items and transcript;
// they never edit, regenerate or delete it.
import { meetlyApi, meetlyMeetingTitle, type MeetlyMeeting, type MeetlyShareUser } from '../../api/meetly';
import SharePeopleDialog from '../../components/SharePeopleDialog';

interface ShareMeetingDialogProps {
  meeting: MeetlyMeeting;
  /** Called with the saved recipient list so the card or view can update. */
  onSaved: (meetingId: string, sharedWith: MeetlyShareUser[]) => void;
  onClose: () => void;
}

export default function ShareMeetingDialog({ meeting, onSaved, onClose }: ShareMeetingDialogProps) {
  return (
    <SharePeopleDialog
      noun="meeting"
      itemTitle={meetlyMeetingTitle(meeting)}
      ownerId={meeting.owner_id || ''}
      initialUserIds={(meeting.shared_with || []).map(person => person.user_id)}
      onSave={async userIds => {
        const res = await meetlyApi.shareMeeting(meeting.id, userIds);
        onSaved(meeting.id, res.data.shared_with);
        return res.data.shared_with.length;
      }}
      onClose={onClose}
    />
  );
}
